import { Component } from '@angular/core';

@Component({
  selector: 'app-help-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './help-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class HelpIconComponent {}
